import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import DraggableItem from './DraggableItem';

type Status = 'default' | 'wrong' | 'correct';

interface DroppableBlankProps {
  blank: any;
  items: any;
  show?: string;
  status?: Status;
}

const DroppableBlank = ({
  blank,
  items,
  show,
  status,
}: DroppableBlankProps) => {
  return (
    <span>
      {show !== 'n' ? (
        <Droppable droppableId={blank.id} isDropDisabled={false}>
          {({ droppableProps, innerRef, placeholder }, { isDraggingOver }) => (
            <div
              className={` ${
                blank.id === 'b-0' ? 'flex' : 'inline-block ml-2'
              }`}
            >
              <span>{blank.label}</span>

              <span
                className={` border border-1 rounded-md  items-center  mx-2 
                ${blank.id === 'b-0' ? ' p-2 rounded gap-2' : 'justify-between'}
                 ${items.length > 1 ? 'flex' : 'inline-flex'}
                 ${
                   isDraggingOver
                     ? ' bg-blue-100 '
                     : `bg-gray-100  ${
                         blank.id !== 'b-0'
                           ? `${
                               status === 'correct'
                                 ? 'bg-green-400  text-white'
                                 : status === 'wrong'
                                 ? 'bg-red-300  text-white'
                                 : 'bg-gray-100 '
                             } `
                           : 'bg-gray-100'
                       }  `
                 }
                `}
                {...droppableProps}
                ref={innerRef}
                style={{
                  minWidth: `${blank.id === 'b-0' ? '90%' : '60px'}`,
                  minHeight: '30px',
                }}
              >
                {items.map((item: any, index: number) => (
                  <DraggableItem
                    item={item}
                    index={index}
                    blankId={blank.id}
                    key={item.id}
                    status={status}
                  />
                ))}
                {items.length === 0 && <span>&#160;</span>}
                {placeholder}
              </span>
            </div>
          )}
        </Droppable>
      ) : (
        <div
          className={`${blank.id === 'b-0' ? '' : ' inline-block text-center'}`}
        >
          <span>{blank.label}</span>
        </div>
      )}
    </span>
  );
};

export default DroppableBlank;
